import type { AnyToolDisplaySpec } from '#plugin-chat/hooks/useToolDisplaySpec.ts';
import { readToolField, useToolsMap } from '#plugin-chat/hooks/useToolsMap.ts';

/**
 * Returns a closure that reports whether a tool is collapsible — derived
 * from the presence of `display.progress` on the tool's model-context entry
 * (attached by the `<Tool>` component).
 *
 * Designed for callers that test many tool names per render
 * (e.g. message-parts iteration). The hook reads the tools map once at the
 * top level; the returned closure does plain object access, so it's safe
 * to call inside reduce/map loops.
 */
export function useIsCollapsibleTool(): (toolName: string | undefined) => boolean {
  const tools = useToolsMap();
  return (toolName) => readToolField<AnyToolDisplaySpec>(tools, toolName, 'display')?.progress != null;
}
